import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import {
  setProgress,
  setVolume,
  setAudio,
  setRounds,
  setPlaying,
  setSelectedRound,
  setbackgroundColor,
  setlogo,
  setfontColor,
  setTeamNames,
  setgameName,
  setTeam1bgColor,
  setTeam2bgColor,
  setButtonColor,
  setfontfamily,
  setlanguage,
  setlocalization,
  setbackgroundImg,
  setIsMobile,
} from "./Redux/action";
import HangManBasic from "./pages/BasicMode/HangManBasic";
import HangManQuestion from "./pages/BasicMode/HangManQuestion";
import HangManPlayScreen from "./pages/BasicMode/HangManPlayScreen";
import HangManWinnerScreen from "./pages/BasicMode/HangManWinnerScreen";
import CircularProgress from "@mui/material/CircularProgress";

import EnterParticipantName from "./pages/CrowdMode/EnterParticipantName";
import EnterPin from "./pages/ClassroomMode/EnterPin";

import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Host from "./pages/CrowdMode/Host";
import AllocatedTeamToParticipant from "./pages/CrowdMode/AllocatedTeamToParticipant";
import WaitingScreen from "./pages/CrowdMode/WaitingScreen";
import LeaderBoard from "./pages/CrowdMode/LeaderBoard";
import PlayScreenParticipant from "./pages/CrowdMode/PlayScreenParticipant";
import PlayerWinnerParticipant from "./pages/CrowdMode/PlayerWinnerParticipant";
import loadingLogoImg from "../src/image/Round-Icon.png";
import firebase from "./firebase";
import axios from "axios";
import useWakeLock from "./pages/useWakeLock";
import "../src/App.css";
import slientaudio from "../src/Sounds/1-minute-of-silence.mp3";
import NoSleep from "nosleep.js";

function HangmanApp() {
  // useWakeLock();
  const dispatch = useDispatch();
  const { id: id } = useParams();
  const [metaData, setMetaData] = useState({ title: "", description: "", favicon: "https://triviamaker.com/TriviaMaker/Theme/v4/HangMan/Cowboy/cowboylogo.png" });
  const [musicData, setMusicData] = useState("");
  const [canPlay, setCanPlay] = useState(false);
  const [duration, setDuration] = useState(0);
  const rounds = useSelector((state) => state.round.rounds);
  const backgroundColor = useSelector(
    (state) => state.backgroundColor.backgroundColor
  );
  const fontColor = useSelector((state) => state.fontColor.fontColor);
  const teamNames = useSelector((state) => state.gameSettings.teamNames);
  const team1bgColor = useSelector((state) => state.gameSettings.team1bgColor);
  const team2bgColor = useSelector((state) => state.gameSettings.team2bgColor);
  const buttonColor = useSelector((state) => state.gameSettings.buttonColor);
  const fontfamily = useSelector((state) => state.gameSettings.fontfamily);
  console.log(fontfamily, "fontfamily");
  const backgroundImg = useSelector(
    (state) => state.backgroundImg.backgroundImg
  );
  const playing = useSelector((state) => state.audio.playing);
  const logo = useSelector((state) => state.logo.logo);
  const volume = useSelector((state) => state.audio.volume);
  const audio = useSelector((state) => state.audio.audio);
  // Loading and progress states
  const [buffer, setBuffer] = React.useState(10);
  const [loading, setLoading] = useState(true);
  const [progress, setProgressState] = useState(0); // Track progress
  const [localProgress, setLocalProgress] = useState(0);
  const [logoLoaded, setLogoLoaded] = useState(false); // New state for logo loading
  const [jsonData, setJsonData] = useState(null);
  const [logoLoadedbackgroundImg, setlogoLoadedbackgroundImg] = useState(false); // New state for logo loading
  const navigate = useNavigate();
  const [currentScreen, setCurrentScreen] = useState(() => {
    const storedScreen = localStorage.getItem("currentScreen");
    return storedScreen || "splash";
  });
  const [timerStarted, setTimerStarted] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Convert all query params to an object
  const allQueryParams = {};
  for (const [key, value] of queryParams.entries()) {
    allQueryParams[key] = value;
  }
  const [loginToastVisible, setLoginToastVisible] = useState(false);
  const loginToastResolveRef = useRef(null);
  const loginToastPromiseRef = useRef(null);
  const showLoginToast = () => {
    // reuse existing pending promise if already shown
    if (!loginToastPromiseRef.current) {
      loginToastPromiseRef.current = new Promise((resolve) => {
        // keep a resolver that handleLoginToastOk will call
        loginToastResolveRef.current = (proceed = true) => {
          resolve(proceed);
          // cleanup
          loginToastPromiseRef.current = null;
          loginToastResolveRef.current = null;
        };
        setLoginToastVisible(true);
      });
    }
    return loginToastPromiseRef.current;
  };

  const handleLoginToastOk = (proceed = true) => {
    // hide toast
    setLoginToastVisible(false);

    // resolve any awaiting promise
    if (typeof loginToastResolveRef.current === "function") {
      try {
        loginToastResolveRef.current(proceed);
      } catch (e) {
        console.error("Error resolving login toast promise:", e);
      }
    }

    // cleanup refs
    loginToastPromiseRef.current = null;
    loginToastResolveRef.current = null;

    // Ensure loading overlay is removed when user confirms
    try {
      setLoading(false);
    } catch (e) {
      // defensive - setLoading should exist in this component
      console.error("setLoading not available:", e);
    }
  };

  useEffect(() => {
    const storedGameId = localStorage.getItem("gameid");

    if (id) {
      // Check for stored game ID mismatch
      if (storedGameId && storedGameId !== id) {
        console.error("Error: URL gameid does not match the stored code.");
        localStorage.clear();
        setCurrentScreen("splash");
      } else {
        localStorage.setItem("gameid", id); // Store new id if no conflict
      }
    } else if (!storedGameId) {
      console.error("Error: Code not found in localStorage or URL.");
    }

  }, [id]);


  useEffect(() => {
    const currentUrl = window.location.href;

    // Use URLSearchParams to handle query parameters
    const urlParams = new URLSearchParams(window.location.search);

    console.log('Current URL:', currentUrl); // Log the full URL for debugging
    console.log('URL Params:', urlParams);   // Log the parsed parameters

    // Check if the URL contains "spacin=30px" in the query string
    if (
      (currentUrl.startsWith("https://www.triviamaker.com/") || currentUrl.startsWith("https://triviamaker.com/"))
      && currentUrl.includes("spacin=30px")
    ) {
      dispatch(setIsMobile(true));    // Set mobile to true when spacin=30px is found
      fetchData();                    // Fetch data
      console.log("mobile function called");  // Debugging log

    } else if (
      (currentUrl.startsWith("https://www.triviamaker.com/") || currentUrl.startsWith("https://triviamaker.com/"))
      && currentUrl.includes("m=play")
    ) {
      // If it starts with "https://triviamaker.com/" and includes "m=play"
      dispatch(setIsMobile(false));  // Set mobile to false for non-mobile
      fetchData();                   // Fetch data for this case
      console.log("fetchData function called");

    } else if (
      currentUrl.startsWith("https://www.triviamaker.com/") || currentUrl.startsWith("https://triviamaker.com/")
    ) {
      // If it only starts with "https://triviamaker.com/"
      dispatch(setIsMobile(false));  // Set mobile to false
      checkSubscription();           // Call checkSubscription
      console.log("checkSubscription function called");

    } else {
      // For any other case, handle it here
      checkSubscriptionforLocal();   // Call checkSubscriptionforLocal
      dispatch(setIsMobile(false));  // Set mobile to false
      console.log("checkSubscriptionforLocal function called");
    }
  }, [id]);




  useEffect(() => {
    // Dynamically set the font family in the root CSS
    console.log('--main-font', fontfamily);
    const selectedFont = fontfamily || 'Museo'; // Default to 'Museo' if no font is set
    document.documentElement.style.setProperty('--main-font', selectedFont); // Apply the dynamic font

  }, [fontfamily]);
  // local
  const checkSubscriptionforLocal = async () => {
    try {
      // First API call to check subscription
      const response = await fetch('https://triviamaker.com/Subscription/checkSubscription.php?userid=P4uQKfFfhTfakuQslIwMETd6t2l2');
      const data = await response.json();

      if (data.premium === false) {
        window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
      } else {
        // If premium and id includes "C", get email
        if (id.includes('C')) {
          console.log('Corporate game');
          try {
            // Fetch the email
            const emailResponse = await fetch(`https://trivia-maker.firebaseio.com/HangMan/${id}/email.json`);
            const email = await emailResponse.json();
            console.log('Email:', email);

            // Fetch team data and check if email is included
            const teamsResponse = await fetch(`https://trivia-maker.firebaseio.com/TMUsers/P4uQKfFfhTfakuQslIwMETd6t2l2/Teams.json`);
            const teamsData = await teamsResponse.json();

            if (teamsData === null || (Array.isArray(teamsData) && !teamsData.includes(email))) {
              // Redirect if teamsData is null or if email is not in the team data
              window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
            } else {
              fetchData(); // Fetch data only if all checks pass
            }
          } catch (error) {
            console.error('Error fetching email or team data:', error);
          }
        } else {
          fetchData();
        }
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
    }
  };
  //  const checkSubscription = async () => {
  //   try {
  //     // Fetch userid dynamically from login API
  //     const urlParams = new URLSearchParams(window.location.search);
  //     if (urlParams.get("m") === "play") {
  //       fetchData();
  //       return; // Skip the rest of the checks
  //     }
  //     const loginResponse = await fetch("https://triviamaker.com/checklogin.php");

  //     if (!loginResponse.ok) {
  //         console.error("HTTP error", loginResponse.status);
  //         return; // Exit the function or handle the error appropriately
  //     }

  //     const responseText = await loginResponse.text(); // Get the raw text response
  //     console.log(responseText, "raw response"); // Log the raw response

  //     const userid = responseText.trim(); // Trim any whitespace
  //     console.log(userid, "userid");

  //     if (!userid || userid.trim() === "") {
  //       window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //       return;
  //     }

  //     // Use dynamic userid for subscription check
  //     const subscriptionResponse = await fetch(
  //       `https://triviamaker.com/Subscription/checkSubscription.php?userid=${userid}`
  //     );
  //     const subscriptionText = await subscriptionResponse.text();

  //     let subscriptionData;
  //     if (subscriptionText) {
  //       // Check if response text is non-empty
  //       try {
  //         subscriptionData = JSON.parse(subscriptionText);
  //       } catch (error) {
  //         console.error(
  //           "Error parsing subscription response:",
  //           subscriptionText
  //         );
  //         return;
  //       }
  //     } else {
  //       console.error("Empty subscription response received");
  //       return;
  //     }

  //     if (subscriptionData && subscriptionData.premium === false) {
  //       window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //     } else {
  //       // If premium and id includes "C", get email
  //       if (id.includes("C")) {
  //         console.log("Corporate game");
  //         try {
  //           // Fetch the email
  //           const emailResponse = await fetch(
  //             `https://trivia-maker.firebaseio.com/HangMan/${id}/email.json`
  //           );
  //           const emailText = await emailResponse.text();

  //           let email;
  //           if (emailText) {
  //             // Check if response text is non-empty
  //             try {
  //               email = JSON.parse(emailText);
  //             } catch (error) {
  //               console.error("Error parsing email response:", emailText);
  //               return;
  //             }
  //           } else {
  //             console.error("Empty email response received");
  //             return;
  //           }

  //           console.log("Email:", email);

  //           // Fetch team data and check if email is included
  //           const teamsResponse = await fetch(
  //             `https://trivia-maker.firebaseio.com/TMUsers/${userid}/Teams.json`
  //           );
  //           const teamsText = await teamsResponse.text();

  //           let teamsData;
  //           if (teamsText) {
  //             // Check if response text is non-empty
  //             try {
  //               teamsData = JSON.parse(teamsText);
  //             } catch (error) {
  //               console.error("Error parsing teams response:", teamsText);
  //               return;
  //             }
  //           } else {
  //             console.error("Empty teams response received");
  //             return;
  //           }

  //           if (
  //             teamsData === null ||
  //             (Array.isArray(teamsData) && !teamsData.includes(email))
  //           ) {
  //             // Redirect if teamsData is null or if email is not in team data
  //             window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //           } else {
  //             fetchData(); // Fetch data only if all checks pass
  //           }
  //         } catch (error) {
  //           console.error("Error fetching email or team data:", error);
  //         }
  //       } else {
  //         fetchData();
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error checking subscription or login:", error);
  //   }
  // };
  const checkSubscription = async () => {
    try {
      // If the URL contains 'iframe', use email from DB as userid
      const url = window.location.href;
      const urlParams = new URLSearchParams(window.location.search);
      let userid;
      if (
        url.includes('/iframe') || url.includes('/embedded') ||
        (urlParams.get("m") === "play")
      ) {
        // Fetch the game data and use email as userid
        const gameRes = await fetch(`https://trivia-maker.firebaseio.com/HangMan/${id}.json`);
        const gameData = await gameRes.json();
        userid = gameData && gameData.email ? gameData.email : null;
        console.log(userid, "userid from game data");
        if (!userid) {
          console.error('No email found in game data for iframe/embedded mode.');
          return;
        }
        // removed else if (urlParams.get("m") === "play") block as requested
      } else {
        // Default logic: Fetch userid dynamically from login API
        // const loginResponse = await fetch("https://triviamaker.com/checklogin.php");
        // if (!loginResponse.ok) {
        //   console.error("HTTP error", loginResponse.status);
        //   return; // Exit the function or handle the error appropriately
        // }
        // const responseText = await loginResponse.text(); // Get the raw text response
        // console.log(responseText, "raw response"); // Log the raw response
        // userid = responseText.trim(); // Trim any whitespace
        // console.log(userid, "userid");

        // if (!userid || userid.trim() === "") {
        //   window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
        //   return;
        // }
        const loginResponse = await fetch("https://triviamaker.com/checklogin.php").catch(() => null);
        if (!loginResponse || !loginResponse.ok) {
          // show modal and wait for operator to click OK (useful for local testing)
          await showLoginToast();
          userid = null;
        } else {
          userid = (await loginResponse.text()).trim();
          if (!userid) {
            // server returned empty userid -> show toast and wait
            await showLoginToast();
            userid = null;
          }
        }
      }

      // Use userid for subscription check
      const subscriptionResponse = await fetch(
        `https://triviamaker.com/Subscription/checkSubscription.php?userid=${userid}`
      );
      const subscriptionText = await subscriptionResponse.text();

      let subscriptionData;
      if (subscriptionText) {
        // Check if response text is non-empty
        try {
          subscriptionData = JSON.parse(subscriptionText);
        } catch (error) {
          console.error(
            "Error parsing subscription response:",
            subscriptionText
          );
          return;
        }
      } else {
        console.error("Empty subscription response received");
        return;
      }

      if (subscriptionData && subscriptionData.premium === false) {
        window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
      } else {
        // If premium and id includes "C", get email
        if (id.includes("C")) {
          console.log("Corporate game");
          try {
            // Fetch the email
            const emailResponse = await fetch(
              `https://trivia-maker.firebaseio.com/HangMan/${id}/email.json`
            );
            const emailText = await emailResponse.text();

            let email;
            if (emailText) {
              // Check if response text is non-empty
              try {
                email = JSON.parse(emailText);
              } catch (error) {
                console.error("Error parsing email response:", emailText);
                return;
              }
            } else {
              console.error("Empty email response received");
              return;
            }

            console.log("Email:", email);

            // Fetch team data and check if email is included
            const teamsResponse = await fetch(
              `https://trivia-maker.firebaseio.com/TMUsers/${userid}/Teams.json`
            );
            const teamsText = await teamsResponse.text();

            let teamsData;
            if (teamsText) {
              // Check if response text is non-empty
              try {
                teamsData = JSON.parse(teamsText);
              } catch (error) {
                console.error("Error parsing teams response:", teamsText);
                return;
              }
            } else {
              console.error("Empty teams response received");
              return;
            }

            if (
              teamsData === null ||
              (Array.isArray(teamsData) && !teamsData.includes(email))
            ) {
              // Redirect if teamsData is null or if email is not in team data
              window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
            } else {
              fetchData(); // Fetch data only if all checks pass
            }
          } catch (error) {
            console.error("Error fetching email or team data:", error);
          }
        } else {
          fetchData();
        }
      }
    } catch (error) {
      console.error("Error checking subscription or login:", error);
    }
  };
  const fetchData = async () => {
    try {
      const response = await fetch(
        // `https://trivia-maker-games.firebaseio.com/hangman/${id}.json`
        `https://trivia-maker.firebaseio.com/HangMan/${id}.json`
      );
      const data = await response.json();

      if (data.Questions) {
        dispatch(setRounds(data.Questions)); // Set rounds in Redux state
      }
      if (data.name) {
        setMetaData({ title: data.name, description: data.gameSetting.Description, favicon: data.gameSetting.Bytes });
        dispatch(setgameName(data.name));
      }
      if (data.gameSetting) {
        if (data.gameSetting.teamNames && data.gameSetting.teamNames.length > 0) {
          dispatch(setTeamNames(data.gameSetting.teamNames)); // Set team names
        } else if (data.gameSetting.Team1 || data.gameSetting.Team2) {
          dispatch(setTeamNames([data.gameSetting.Team1 || "Team 1", data.gameSetting.Team2 || "Team 2"]));
        } else {
          dispatch(setTeamNames(["Team 1", "Team 2"]));
        }
        if (data.gameSetting.Team1bgColor) {
          dispatch(setTeam1bgColor(`#${data.gameSetting.Team1bgColor}`)); // Set Team 1 background color
        }
        if (data.gameSetting.Team2bgColor) {
          dispatch(setTeam2bgColor(`#${data.gameSetting.Team2bgColor}`)); // Set Team 2 background color
        }
        if (data.gameSetting.buttonColor) {
          dispatch(setButtonColor(`#${data.gameSetting.buttonColor}`)); // Set button color
        }
        if (data.gameSetting.IsFontFamily) {
          dispatch(setfontfamily(`${data.gameSetting.IsFontFamily}`)); // Set button color

        }
        if (data.gameSetting.backgroundColor) {
          dispatch(setbackgroundColor(`#${data.gameSetting.backgroundColor}`)); // Set background color
        }
        if (data.gameSetting.backgroundImageUrl) {
          dispatch(setbackgroundImg(data.gameSetting.backgroundImageUrl)); // No `#` prefix needed
          const img = new Image();
          img.src = data.gameSetting.backgroundImageUrl; // Assuming this is the logo URL
          img.onload = () => setlogoLoadedbackgroundImg(true);
        } else {
          const defaultBackgroundUrl = "https://triviamaker.com/TriviaMaker/Theme/v4/HangMan/Cowboy/cowboyBG.jpg";
          dispatch(setbackgroundImg(defaultBackgroundUrl));
          const img = new Image();
          img.src = defaultBackgroundUrl;
          img.onload = () => setlogoLoadedbackgroundImg(true);
        }
        if (data.gameSetting.Bytes) {
          dispatch(setlogo(data.gameSetting.Bytes)); // Set logo
          const img = new Image();
          img.src = data.gameSetting.Bytes; // Assuming this is the logo URL
          img.onload = () => setLogoLoaded(true);
        } else {
          const defaultLogoUrl =
            "https://triviamaker.com/TriviaMaker/Theme/v4/HangMan/Cowboy/cowboylogo.png";
          dispatch(setlogo(defaultLogoUrl));
          const img = new Image();
          img.src = defaultLogoUrl;
          img.onload = () => setLogoLoaded(true);
        }
        if (data.gameSetting.fontColor) {
          dispatch(setfontColor(`#${data.gameSetting.fontColor}`)); // Set font color
        }
      }
      if (data.language) {
        dispatch(setlanguage(data.language || 'en')); // Set language if available
        const translationModule = await import(`../src/languages/${data.language}.json`);
        const parsedJson = translationModule.default;  // Get the parsed JSON
        setJsonData(parsedJson);  // Set parsed JSON to state
        dispatch(setlocalization(parsedJson));
      }

      if (data.gameSetting.musicLink) {
        setMusicData(data.gameSetting.musicLink);
        localStorage.setItem("musicLink", data.gameSetting.musicLink);
        const audioObject = new Audio(data.gameSetting.musicLink);
        audioObject.preload = "auto";
        audioObject.volume = volume / 100; // Set initial volume
        dispatch(setAudio(audioObject));

        audioObject.addEventListener("timeupdate", () => {
          const progress =
            (audioObject.currentTime / audioObject.duration) * 100;
          dispatch(setProgress(progress));
        });
      }

      setLoading(false); // Set loading to false once all data is fetched
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Update the favicon dynamically
    const faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
      faviconLink.href = metaData.favicon;
    } else {
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = metaData.favicon;
      document.head.appendChild(link);
    }
  }, [metaData.favicon]);


  useEffect(() => {
    const handleBeforeUnload = () => {
      const startTime = Date.now();
      localStorage.setItem("startTime", startTime.toString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    const currentUrl = window.location.href;

    const checkExpiration = () => {
      const storedStartTime = localStorage.getItem("startTime");
      let elapsedTime;

      if (storedStartTime) {
        const startTime = parseInt(storedStartTime, 10);
        const currentTime = Date.now();

        // Set elapsedTime based on URL condition
        if (currentUrl.includes("spacin=30px")) {
          elapsedTime = 15 * 60 * 1000; // 15 minutes in milliseconds
        } else {
          elapsedTime = currentTime - startTime;
        }

        // Check if elapsedTime meets or exceeds 10 minutes
        if (elapsedTime >= 10 * 60 * 1000) {
          // Remove local storage items
          localStorage.removeItem("roundWinners");
          localStorage.removeItem("score");
          localStorage.removeItem("selectedRound");
          localStorage.removeItem("currentScreen");
          localStorage.removeItem("wordToGuess");
          localStorage.removeItem("guessedLetters");
          localStorage.removeItem("wrongGuesses");
          localStorage.removeItem("currentTeam");
          localStorage.removeItem("startTime");
          if (!currentUrl.includes("spacin=30px")) {
            window.location.reload();
          }
          // Optionally reload the page
        } else {
          console.log("Data is still valid.");
          // Reset timer
          localStorage.removeItem("startTime");
        }
      }
    };

    // Check expiration on component mount
    checkExpiration();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleNavigate = (screen) => {
    setCurrentScreen(screen);
    localStorage.setItem("currentScreen", screen);
  };


  useEffect(() => {
    const updateLocalProgress = () => {
      setLocalProgress(progress);
    };

    updateLocalProgress();
  }, [progress]);

  useEffect(() => {
    const handleUserInteraction = () => {
      setCanPlay(true);
    };

    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    if (canPlay && audio) {
      audio.volume = volume / 100;
      dispatch(setPlaying(true));
      audio.play().catch((error) => {
        dispatch(setPlaying(false));
        console.error("Error playing audio:", error);
      });
    }
  }, [audio, canPlay, volume]);

  useEffect(() => {
    const handleResize = () => {
      const isMobileLandscape =
        window.innerWidth > window.innerHeight && window.innerWidth <= 1020;

      if (window.innerHeight <= 720) {
        // Enable scroll when the window is minimized or small in size
        if (isMobileLandscape) {
          // Remove scroll for mobile landscape mode
          document.body.style.overflowY = "hidden";
          document.body.style.overflowX = "hidden";
        } else {
          // Enable scroll for minimized window on desktop or other conditions
          document.body.style.overflowY = "scroll";
          document.body.style.overflowX = "scroll";
        }
      } else {
        // Disable scroll for larger screens
        document.body.style.overflowY = "hidden";
        document.body.style.overflowX = "hidden";
      }
    };

    // Add the resize event listener
    window.addEventListener("resize", handleResize);

    // Call it on mount to set initial scroll behavior
    handleResize();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // <--- Add an empty dependency array

  return (
    <>
      <Helmet>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
      </Helmet>
      <div className="App">
        {loading || !logoLoaded || !logoLoadedbackgroundImg ? (
          // {!loading || !logoLoaded || !logoLoadedbackgroundImg ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              // backgroundColor: "rgba(0, 0, 0, 0.5)",
              background: "linear-gradient(#2e9093, #27738e)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column", // Centering and aligning content vertically
            }}
          >
            <img src={loadingLogoImg} alt="loading" className=" appLogoImg" />
            {/* LinearProgress at the bottom */}
            <Box
              sx={{
                width: "calc(100% - 400px)", // Adjust width to account for left and right margins
                position: "fixed",
                bottom: 150, // Adjust as needed for your layout
                marginLeft: "20px", // Set left margin
                marginRight: "20px", // Set right margin
              }}
            >
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  backgroundColor: "", // Buffer track color (faded white)
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "white", // Progress bar color
                  },
                }}
              />
            </Box>
            {/* Dev test button (only on localhost) */}
            {window.location.hostname === "localhost" && (
              <div style={{ position: "fixed", bottom: 20, left: 20, zIndex: 10000 }}>
                <button
                  onClick={() => setLoginToastVisible(true)}
                  style={{
                    background: "#f39c12",
                    color: "white",
                    border: "none",
                    padding: "8px 12px",
                    borderRadius: 6,
                    cursor: "pointer"
                  }}
                >
                  Open login Toast (dev)
                </button>
              </div>
            )}
            {loginToastVisible && (
              <div
                role="alert"
                aria-live="assertive"
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 13000,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between", // push button to bottom
                  gap: 12,
                  background: "#fff",
                  color: "red",
                  padding: "18px",
                  borderRadius: 10,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
                  maxWidth: 420,
                  width: "min(420px, calc(100% - 40px))",
                  minHeight: 96, // give enough vertical space for separation
                  boxSizing: "border-box",
                }}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <div style={{ fontSize: 30, lineHeight: 1 }}>⚠️</div>
                  <div style={{ flex: 1, minWidth: 0, textAlign: "left" }}>
                    <div style={{ fontWeight: 800, marginBottom: 6, fontSize: 16 }}>
                      You're not logged in.
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.95, lineHeight: 1.3 }}>
                      Some features are limited in guest mode. Log in to unlock your full game access.
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                  <button
                    onClick={() => {
                      window.location.href = `https://triviamaker.com/login/?action=Play/hangman/${id}`;
                    }}
                    style={{
                      background: "linear-gradient(rgb(46, 144, 147), rgb(39, 115, 142))",
                      color: "white",
                      border: "none",
                      padding: "8px 14px",
                      borderRadius: 6,
                      cursor: "pointer",
                      fontWeight: 500,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.18)"
                    }}
                  >
                    Log in & continue
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            {currentScreen === "splash" && (
              <HangManBasic onNavigate={handleNavigate} />
            )}
            {currentScreen === "question" && (
              <HangManQuestion onNavigate={handleNavigate} />
            )}
            {currentScreen === "playscreen" && (
              <HangManPlayScreen onNavigate={handleNavigate} />
            )}
            {currentScreen === "winnerscreen" && (
              <HangManWinnerScreen onNavigate={handleNavigate} />
            )}
          </>
        )}
      </div>
    </>
  );
}

function HangManCrowdMode() {
  // useWakeLock();
  const dispatch = useDispatch();
  const { id: id } = useParams();
  const { clid: clid } = useParams();
  console.log(clid, "clid");
  const [loading, setLoading] = useState(true);
  const [localProgress, setLocalProgress] = useState(0);
  const [logoLoaded, setLogoLoaded] = useState(false); // New state for logo loading
  const [logoLoadedbackgroundImg, setlogoLoadedbackgroundImg] = useState(false); // New state for logo loading
  const [musicData, setMusicData] = useState("");
  const volume = useSelector((state) => state.audio.volume);
  const audio = useSelector((state) => state.audio.audio);
  const [jsonData, setJsonData] = useState(null);
  const [canPlay, setCanPlay] = useState(false);
  const [progress, setProgressState] = useState(0);
  const [buffer, setBuffer] = React.useState(10);
  const code = localStorage.getItem("code");
  const fontfamily = useSelector((state) => state.gameSettings.fontfamily);
  const [metaData, setMetaData] = useState({ title: "", description: "", favicon: "https://triviamaker.com/TriviaMaker/Theme/v4/HangMan/Cowboy/cowboylogo.png" });
  console.log(fontfamily, "fontfamily");
  console.log(code, "code");
  const [currentScreen, setCurrentScreen] = useState(() => {
    const storedScreen = localStorage.getItem("currentScreen");
    return storedScreen || "Host";
  });
  const handleNavigate = (screen) => {
    setCurrentScreen(screen);
    localStorage.setItem("currentScreen", screen);
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loginToastVisible, setLoginToastVisible] = useState(false);
  const loginToastResolveRef = useRef(null);
  const loginToastPromiseRef = useRef(null);
  const showLoginToast = () => {
    // reuse existing pending promise if already shown
    if (!loginToastPromiseRef.current) {
      loginToastPromiseRef.current = new Promise((resolve) => {
        // keep a resolver that handleLoginToastOk will call
        loginToastResolveRef.current = (proceed = true) => {
          resolve(proceed);
          // cleanup
          loginToastPromiseRef.current = null;
          loginToastResolveRef.current = null;
        };
        setLoginToastVisible(true);
      });
    }
    return loginToastPromiseRef.current;
  };

  const handleLoginToastOk = (proceed = true) => {
    // hide toast
    setLoginToastVisible(false);

    // resolve any awaiting promise
    if (typeof loginToastResolveRef.current === "function") {
      try {
        loginToastResolveRef.current(proceed);
      } catch (e) {
        console.error("Error resolving login toast promise:", e);
      }
    }

    // cleanup refs
    loginToastPromiseRef.current = null;
    loginToastResolveRef.current = null;

    // Ensure loading overlay is removed when user confirms
    try {
      setLoading(false);
    } catch (e) {
      // defensive - setLoading should exist in this component
      console.error("setLoading not available:", e);
    }
  };
  // Convert all query params to an object
  const allQueryParams = {};
  for (const [key, value] of queryParams.entries()) {
    allQueryParams[key] = value;
  }
  const [timerStarted, setTimerStarted] = useState(false);
  useEffect(() => {
    const handleBeforeUnload = () => {
      const startTime = Date.now();
      localStorage.setItem("startTime", startTime.toString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    const currentUrl = window.location.href;

    const checkExpiration = () => {
      const storedStartTime = localStorage.getItem("startTime");
      let elapsedTime;

      if (storedStartTime) {
        const startTime = parseInt(storedStartTime, 10);
        const currentTime = Date.now();

        // Set elapsedTime based on URL condition
        if (currentUrl.includes("spacin=30px")) {
          elapsedTime = 15 * 60 * 1000; // 15 minutes in milliseconds
        } else {
          elapsedTime = currentTime - startTime;
        }

        // Check if elapsedTime meets or exceeds 10 minutes
        if (elapsedTime >= 10 * 60 * 1000) {
          // Remove local storage items
          localStorage.removeItem("roundWinners");
          localStorage.removeItem("score");
          localStorage.removeItem("selectedRound");
          localStorage.removeItem("currentScreen");
          localStorage.removeItem("wordToGuess");
          localStorage.removeItem("guessedLetters");
          localStorage.removeItem("wrongGuesses");
          localStorage.removeItem("currentTeam");
          localStorage.removeItem("startTime");
          if (!currentUrl.includes("spacin=30px")) {
            window.location.reload();
          }
          // Optionally reload the page
        } else {
          console.log("Data is still valid.");
          // Reset timer
          localStorage.removeItem("startTime");
        }
      }
    };

    // Check expiration on component mount
    checkExpiration();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  useEffect(() => {
    const storedGameId = localStorage.getItem("gameid");
    console.log('id', id);
    if (id) {
      // Check for stored game ID mismatch
      if (storedGameId && storedGameId !== id) {
        console.error("Error: URL gameid does not match the stored code.");
        localStorage.clear();
        setCurrentScreen("Host");
      } else {
        localStorage.setItem("gameid", id); // Store new id if no conflict
      }
    } else if (!storedGameId) {
      console.error("Error: Code not found in localStorage or URL.");
    }

  }, [id]);

  useEffect(() => {
    const currentUrl = window.location.href;

    // Use URLSearchParams to handle query parameters
    const urlParams = new URLSearchParams(window.location.search);

    console.log('Current URL:', currentUrl); // Log the full URL for debugging
    console.log('URL Params:', urlParams);   // Log the parsed parameters

    // Check if the URL contains "spacin=30px" in the query string
    if (
      (currentUrl.startsWith("https://www.triviamaker.com/") || currentUrl.startsWith("https://triviamaker.com/"))
      && currentUrl.includes("spacin=30px")
    ) {
      dispatch(setIsMobile(true));    // Set mobile to true when spacin=30px is found
      fetchData();                    // Fetch data
      console.log("mobile function called");  // Debugging log

    } else if (
      (currentUrl.startsWith("https://www.triviamaker.com/") || currentUrl.startsWith("https://triviamaker.com/"))
      && currentUrl.includes("m=play")
    ) {
      // If it starts with "https://triviamaker.com/" and includes "m=play"
      dispatch(setIsMobile(false));  // Set mobile to false for non-mobile
      fetchData();                   // Fetch data for this case
      console.log("fetchData function called");

    } else if (
      currentUrl.startsWith("https://www.triviamaker.com/") || currentUrl.startsWith("https://triviamaker.com/")
    ) {
      // If it only starts with "https://triviamaker.com/"
      dispatch(setIsMobile(false));  // Set mobile to false
      checkSubscription();           // Call checkSubscription
      console.log("checkSubscription function called");

    } else {
      // For any other case, handle it here
      checkSubscriptionforLocal();   // Call checkSubscriptionforLocal
      dispatch(setIsMobile(false));  // Set mobile to false
      console.log("checkSubscriptionforLocal function called");
    }
  }, [id]);

  //  local
  const checkSubscriptionforLocal = async () => {
    try {
      // First API call to check subscription
      const response = await fetch('https://triviamaker.com/Subscription/checkSubscription.php?userid=KSVjwd6FVAeWrFPYCGfVTLcuNrn2');
      const data = await response.json();

      if (data.premium === false) {
        window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
      } else {
        // If premium and id includes "C", get email
        if (id.includes('C')) {
          console.log('Corporate game');
          try {
            // Fetch the email
            const emailResponse = await fetch(`https://trivia-maker.firebaseio.com/HangMan/${id}/email.json`);
            const email = await emailResponse.json();
            console.log('Email:', email);

            // Fetch team data and check if email is included
            const teamsResponse = await fetch(`https://trivia-maker.firebaseio.com/TMUsers/KSVjwd6FVAeWrFPYCGfVTLcuNrn2/Teams.json`);
            const teamsData = await teamsResponse.json();

            if (teamsData === null || (Array.isArray(teamsData) && !teamsData.includes(email))) {
              // Redirect if teamsData is null or if email is not in the team data
              window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
            } else {
              fetchData(); // Fetch data only if all checks pass
            }
          } catch (error) {
            console.error('Error fetching email or team data:', error);
          }
        } else {
          fetchData();
        }
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
    }
  };

  // Live
  // useEffect(() => {
  // const checkSubscription = async () => {
  //   try {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     if (urlParams.get("m") === "play") {
  //       fetchData();
  //       return; // Skip the rest of the checks
  //     }
  //     // Fetch userid dynamically from login API
  //     const loginResponse = await fetch(
  //       "https://triviamaker.com/checklogin.php"
  //     );
  //     const userid = await loginResponse.text(); // Directly assign text response to userid

  //     console.log(userid, "userid");

  //     if (!userid || userid.trim() === "") {
  //       window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //       return;
  //     }

  //     // Use dynamic userid for subscription check
  //     const subscriptionResponse = await fetch(
  //       `https://triviamaker.com/Subscription/checkSubscription.php?userid=${userid}`
  //     );
  //     const subscriptionText = await subscriptionResponse.text();

  //     let subscriptionData;
  //     if (subscriptionText) {
  //       // Check if response text is non-empty
  //       try {
  //         subscriptionData = JSON.parse(subscriptionText);
  //       } catch (error) {
  //         console.error(
  //           "Error parsing subscription response:",
  //           subscriptionText
  //         );
  //         return;
  //       }
  //     } else {
  //       console.error("Empty subscription response received");
  //       return;
  //     }

  //     if (subscriptionData && subscriptionData.premium === false) {
  //       window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //     } else {
  //       // If premium and id includes "C", get email
  //       if (id.includes("C")) {
  //         console.log("Corporate game");
  //         try {
  //           // Fetch the email
  //           const emailResponse = await fetch(
  //             `https://trivia-maker.firebaseio.com/HangMan/${id}/email.json`
  //           );
  //           const emailText = await emailResponse.text();

  //           let email;
  //           if (emailText) {
  //             // Check if response text is non-empty
  //             try {
  //               email = JSON.parse(emailText);
  //             } catch (error) {
  //               console.error("Error parsing email response:", emailText);
  //               return;
  //             }
  //           } else {
  //             console.error("Empty email response received");
  //             return;
  //           }

  //           console.log("Email:", email);

  //           // Fetch team data and check if email is included
  //           const teamsResponse = await fetch(
  //             `https://trivia-maker.firebaseio.com/TMUsers/${userid}/Teams.json`
  //           );
  //           const teamsText = await teamsResponse.text();

  //           let teamsData;
  //           if (teamsText) {
  //             // Check if response text is non-empty
  //             try {
  //               teamsData = JSON.parse(teamsText);
  //             } catch (error) {
  //               console.error("Error parsing teams response:", teamsText);
  //               return;
  //             }
  //           } else {
  //             console.error("Empty teams response received");
  //             return;
  //           }

  //           if (
  //             teamsData === null ||
  //             (Array.isArray(teamsData) && !teamsData.includes(email))
  //           ) {
  //             // Redirect if teamsData is null or if email is not in team data
  //             window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
  //           } else {
  //             fetchData(); // Fetch data only if all checks pass
  //           }
  //         } catch (error) {
  //           console.error("Error fetching email or team data:", error);
  //         }
  //       } else {
  //         fetchData();
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error checking subscription or login:", error);
  //   }
  // };

  //   checkSubscription();
  // }, [id]);
  const checkSubscription = async () => {
    try {
      let userid; // <-- Declare userid here!
      // Fetch userid dynamically from login API
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("m") === "play") {
        fetchData();
        return; // Skip the rest of the checks
      }
      const loginResponse = await fetch("https://triviamaker.com/checklogin.php").catch(() => null);
      if (!loginResponse || !loginResponse.ok) {
        // show modal and wait for operator to click OK (useful for local testing)
        await showLoginToast();
        userid = null;
      } else {
        userid = (await loginResponse.text()).trim();
        if (!userid) {
          // server returned empty userid -> show toast and wait
          await showLoginToast();
          userid = null;
        }
      }
      // Use dynamic userid for subscription check
      const subscriptionResponse = await fetch(
        `https://triviamaker.com/Subscription/checkSubscription.php?userid=${userid}`
      );
      const subscriptionText = await subscriptionResponse.text();

      let subscriptionData;
      if (subscriptionText) {
        // Check if response text is non-empty
        try {
          subscriptionData = JSON.parse(subscriptionText);
        } catch (error) {
          console.error(
            "Error parsing subscription response:",
            subscriptionText
          );
          return;
        }
      } else {
        console.error("Empty subscription response received");
        return;
      }

      if (subscriptionData && subscriptionData.premium === false) {
        window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
      } else {
        // If premium and id includes "C", get email
        if (id.includes("C")) {
          console.log("Corporate game");
          try {
            // Fetch the email
            const emailResponse = await fetch(
              `https://trivia-maker.firebaseio.com/HangMan/${id}/email.json`
            );
            const emailText = await emailResponse.text();

            let email;
            if (emailText) {
              // Check if response text is non-empty
              try {
                email = JSON.parse(emailText);
              } catch (error) {
                console.error("Error parsing email response:", emailText);
                return;
              }
            } else {
              console.error("Empty email response received");
              return;
            }

            console.log("Email:", email);

            // Fetch team data and check if email is included
            const teamsResponse = await fetch(
              `https://trivia-maker.firebaseio.com/TMUsers/${userid}/Teams.json`
            );
            const teamsText = await teamsResponse.text();

            let teamsData;
            if (teamsText) {
              // Check if response text is non-empty
              try {
                teamsData = JSON.parse(teamsText);
              } catch (error) {
                console.error("Error parsing teams response:", teamsText);
                return;
              }
            } else {
              console.error("Empty teams response received");
              return;
            }

            if (
              teamsData === null ||
              (Array.isArray(teamsData) && !teamsData.includes(email))
            ) {
              // Redirect if teamsData is null or if email is not in team data
              window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
            } else {
              fetchData(); // Fetch data only if all checks pass
            }
          } catch (error) {
            console.error("Error fetching email or team data:", error);
          }
        } else {
          fetchData();
        }
      }
    } catch (error) {
      console.error("Error checking subscription or login:", error);
    }
  };

  useEffect(() => {
    // Dynamically set the font family in the root CSS
    console.log('--main-font', fontfamily);

    const selectedFont = fontfamily || 'Museo'; // Default to 'Museo' if no font is set
    document.documentElement.style.setProperty('--main-font', selectedFont); // Apply the dynamic font

  }, [fontfamily]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        // `https://trivia-maker-games.firebaseio.com/hangman/${id}.json`
        `https://trivia-maker.firebaseio.com/HangMan/${id}.json`
      );
      const data = await response.json();
      console.log(data, "Fetched data"); // Log fetched data to inspect the structure
      if (data.Questions) {
        dispatch(setRounds(data.Questions)); // Set rounds in Redux state
      }
      if (data.name) {
        setMetaData({ title: data.name, description: data.gameSetting.Description, favicon: data.gameSetting.Bytes });
        dispatch(setgameName(data.name));
      }

      if (data && data.gameSetting) {
        console.log(data.gameSetting, "Game settings"); // Log game settings for further inspection

        if (data.gameSetting.teamNames && data.gameSetting.teamNames.length > 0) {
          dispatch(setTeamNames(data.gameSetting.teamNames)); // Set team names
        } else if (data.gameSetting.Team1 || data.gameSetting.Team2) {
          dispatch(setTeamNames([data.gameSetting.Team1 || "Team 1", data.gameSetting.Team2 || "Team 2"]));
        } else {
          dispatch(setTeamNames(["Team 1", "Team 2"])); // Fallback team names
        }

        // Set Team 1 background color if it exists
        if (data.gameSetting.Team1bgColor) {
          console.log(`Team 1 Color: ${data.gameSetting.Team1bgColor}`); // Log Team 1 color
          dispatch(setTeam1bgColor(`#${data.gameSetting.Team1bgColor}`)); // Set Team 1 background color
        }

        // Set Team 2 background color if it exists
        if (data.gameSetting.Team2bgColor) {
          console.log(`Team 2 Color: ${data.gameSetting.Team2bgColor}`); // Log Team 2 color
          dispatch(setTeam2bgColor(`#${data.gameSetting.Team2bgColor}`)); // Set Team 2 background color
        }

        // Set button color
        if (data.gameSetting.buttonColor) {
          dispatch(setButtonColor(`#${data.gameSetting.buttonColor}`));
        }
        if (data.gameSetting.IsFontFamily) {
          dispatch(setfontfamily(`${data.gameSetting.IsFontFamily}`)); // Set button color
        }
        // Set background color and background image
        if (data.gameSetting.backgroundColor) {
          dispatch(setbackgroundColor(`#${data.gameSetting.backgroundColor}`));
        }
        if (data.gameSetting.backgroundImageUrl) {
          dispatch(setbackgroundImg(data.gameSetting.backgroundImageUrl)); // No `#` prefix needed
          const img = new Image();
          img.src = data.gameSetting.backgroundImageUrl; // Assuming this is the logo URL
          img.onload = () => setlogoLoadedbackgroundImg(true);
        } else {
          const defaultBackgroundUrl = "https://triviamaker.com/TriviaMaker/Theme/v4/HangMan/Cowboy/cowboyBG.jpg";
          dispatch(setbackgroundImg(defaultBackgroundUrl));
          const img = new Image();
          img.src = defaultBackgroundUrl;
          img.onload = () => setlogoLoadedbackgroundImg(true);
        }

        // Set the logo image
        if (data.gameSetting.Bytes) {
          dispatch(setlogo(data.gameSetting.Bytes)); // Set logo
          const img = new Image();
          img.src = data.gameSetting.Bytes; // Assuming this is the logo URL
          img.onload = () => setLogoLoaded(true);
        } else {
          const defaultLogoUrl =
            "https://triviamaker.com/TriviaMaker/Theme/v4/HangMan/Cowboy/cowboylogo.png";
          dispatch(setlogo(defaultLogoUrl));
          const img = new Image();
          img.src = defaultLogoUrl;
          img.onload = () => setLogoLoaded(true);
        }

        // Set font color
        if (data.gameSetting.fontColor) {
          dispatch(setfontColor(`#${data.gameSetting.fontColor}`));
        }
        if (data.language) {
          dispatch(setlanguage(data.language || 'en')); // Set language if available
          const translationModule = await import(`../src/languages/${data.language}.json`);
          const parsedJson = translationModule.default;  // Get the parsed JSON
          setJsonData(parsedJson);  // Set parsed JSON to state
          dispatch(setlocalization(parsedJson));
        }
        // Handle music link and audio
        if (data.gameSetting.musicLink) {
          setMusicData(data.gameSetting.musicLink);
          localStorage.setItem("musicLink", data.gameSetting.musicLink);
          const audioObject = new Audio(data.gameSetting.musicLink);
          audioObject.preload = "auto";
          audioObject.volume = volume / 100; // Set initial volume
          dispatch(setAudio(audioObject));

          audioObject.addEventListener("timeupdate", () => {
            const progress =
              (audioObject.currentTime / audioObject.duration) * 100;
            dispatch(setProgress(progress));
          });
        }
      }

      setLoading(false); // Set loading to false once all data is fetched
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    // Update the favicon dynamically
    const faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
      faviconLink.href = metaData.favicon;
    } else {
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = metaData.favicon;
      document.head.appendChild(link);
    }
  }, [metaData.favicon]);


  useEffect(() => {
    const handleUserInteraction = () => {
      setCanPlay(true);
    };

    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    if (canPlay && audio) {
      audio.volume = volume / 100;
      dispatch(setPlaying(true));
      audio.play().catch((error) => {
        dispatch(setPlaying(false));
        console.error("Error playing audio:", error);
      });
    }
  }, [audio, canPlay, volume]);

  return (
    <>
      <Helmet>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
      </Helmet>
      <div className="App">
        {loading || !logoLoaded || !logoLoadedbackgroundImg ? (
          // {!loading || !logoLoaded || !logoLoadedbackgroundImg ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              // backgroundColor: "rgba(0, 0, 0, 0.5)",
              background: "linear-gradient(#2e9093, #27738e)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column", // Centering and aligning content vertically
            }}
          >
            <img src={loadingLogoImg} alt="loading" className="appLogoImg" />
            {/* LinearProgress at the bottom */}
            <Box
              sx={{
                width: "calc(100% - 400px)", // Adjust width to account for left and right margins
                position: "fixed",
                bottom: 150, // Adjust as needed for your layout
                marginLeft: "20px", // Set left margin
                marginRight: "20px", // Set right margin
              }}
            >
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  backgroundColor: "", // Buffer track color (faded white)
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "white", // Progress bar color
                  },
                }}
              />
            </Box>
            {window.location.hostname === "localhost" && (
              <div style={{ position: "fixed", bottom: 20, left: 20, zIndex: 10000 }}>
                <button
                  onClick={() => setLoginToastVisible(true)}
                  style={{
                    background: "#f39c12",
                    color: "white",
                    border: "none",
                    padding: "8px 12px",
                    borderRadius: 6,
                    cursor: "pointer"
                  }}
                >
                  Open login Toast (dev)
                </button>
              </div>
            )}
            {loginToastVisible && (
              <div
                role="alert"
                aria-live="assertive"
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 13000,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between", // push button to bottom
                  gap: 12,
                  background: "#fff",
                  color: "red",
                  padding: "18px",
                  borderRadius: 10,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
                  maxWidth: 420,
                  width: "min(420px, calc(100% - 40px))",
                  minHeight: 96, // give enough vertical space for separation
                  boxSizing: "border-box",
                }}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <div style={{ fontSize: 30, lineHeight: 1 }}>⚠️</div>
                  <div style={{ flex: 1, minWidth: 0, textAlign: "left" }}>
                    <div style={{ fontWeight: 800, marginBottom: 6, fontSize: 16 }}>
                      You're not logged in.
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.95, lineHeight: 1.3 }}>
                      Some features are limited in guest mode. Log in to unlock your full game access.
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                  <button
                    onClick={() => {
                      window.location.href = `https://triviamaker.com/login/?action=Play/hangman/${id}/m=cr`;
                    }}
                    style={{
                      background: "linear-gradient(rgb(46, 144, 147), rgb(39, 115, 142))",
                      color: "white",
                      border: "none",
                      padding: "8px 14px",
                      borderRadius: 6,
                      cursor: "pointer",
                      fontWeight: 500,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.18)"
                    }}
                  >
                    Log in & continue
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            {currentScreen === "Host" && <Host onNavigate={handleNavigate} />}
            {currentScreen === "splash" && (
              <HangManBasic onNavigate={handleNavigate} />
            )}
            {currentScreen === "question" && (
              <HangManQuestion onNavigate={handleNavigate} />
            )}
            {currentScreen === "playscreen" && (
              <HangManPlayScreen onNavigate={handleNavigate} />
            )}
            {currentScreen === "winnerscreen" && (
              <HangManWinnerScreen onNavigate={handleNavigate} />
            )}
          </>
        )}
      </div>
    </>
  ); // Implement the actual logic for crowd mode here
}
function HangManCrowdModeParticipantside({ playCode }) {
  const noSleep = new NoSleep();
  const dispatch = useDispatch();
  const { code: urlCode } = useParams();
  const [searchParams] = useSearchParams();

  // Resolve code from props, URL params, query params, or localStorage
  const code = playCode || urlCode || searchParams.get("p") || localStorage.getItem("code");

  // Global exitgame handler for WebView - always available on every participant screen
  // When WebView calls exitgame(), just clean up and redirect - do NOT delete database
  useEffect(() => {
    const handler = () => {
      console.log("exitgame: participant side called");
      console.log("exitgame: current screen:", localStorage.getItem("currentScreenParticipantside"));
      console.log("exitgame: code:", code);

      // Clean up localStorage
      const keysToRemove = [
        'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
        'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
        'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
      ];
      keysToRemove.forEach((key) => window.localStorage.removeItem(key));
      console.log("exitgame: localStorage cleared");

      // Native bridge for iOS
      const isIOSNative = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeProcess);

      if (isIOSNative) {
        try {
          window.webkit.messageHandlers.nativeProcess.postMessage("ExitGame");
          console.log("exitgame: sent ExitGame to native bridge");
        } catch (e) {
          console.error("exitgame: native bridge error:", e);
        }
      } else {
        // Redirect to play.triviamaker.com for browsers
        console.log("exitgame: redirecting to play.triviamaker.com");
        setTimeout(() => {
          window.location.href = 'https://play.triviamaker.com/';
        }, 200);
      }
    };

    window._exitgameReactHandler = handler;
    window.exitgame = handler;
    console.log("exitgame: handler registered on participant side");
  });

  const [loading, setLoading] = useState(true);
  const [progress, setProgressState] = useState(0);
  const [localProgress, setLocalProgress] = useState(0);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [logoLoadedbackgroundImg, setLogoLoadedbackgroundImg] = useState(false);
  const fontfamily = useSelector((state) => state.gameSettings.fontfamily);
  const [wakeLock, setWakeLock] = useState(null);
  const [currentScreen, setCurrentScreen] = useState(() => {
    const storedScreen = localStorage.getItem("currentScreenParticipantside");
    return storedScreen ? storedScreen : "EnterParticipantName";
  });
  const [jsonData, setJsonData] = useState(null);

  const handleNavigate = (screen) => {
    setCurrentScreen(screen);
    localStorage.setItem("currentScreenParticipantside", screen);
  };

  useEffect(() => {
    if (!code) {
      window.location.href = "https://play.triviamaker.com/";
    }
    console.log("Game code:", code);
  }, [code]);


  useEffect(() => {
    let startY = 0;  // To track the initial Y position on touch start

    const handleTouchStart = (e) => {
      // Record the starting Y position when the touch starts
      startY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;

      // Check if the user is at the top of the page and performing a downward scroll
      if (window.scrollY === 0 && currentY > startY) {
        e.preventDefault();  // Prevent the pull-to-refresh
      }
    };

    // Add touch event listeners
    document.addEventListener('touchstart', handleTouchStart, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  useEffect(() => {
    // Dynamically set the font family in the root CSS
    console.log('--main-font', fontfamily);
    const selectedFont = fontfamily || 'Museo'; // Default to 'Museo' if no font is set
    document.documentElement.style.setProperty('--main-font', selectedFont); // Apply the dynamic font

  }, [fontfamily]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const startTime = Date.now();
      localStorage.setItem("startTime", startTime.toString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    const checkExpiration = async () => {
      try {
        const response = await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`);
        const data = await response.json();
        dispatch(setfontfamily(`${data.fontfamily}`));
        // console.log(data.fontfamily, "data.IsFontFamily");
        if (!data) {
          // If no data is returned, the game data is not available, consider the game not started
          console.log("No data found for the game.");
        } else if (data.isParticipantGameStarted === false) {
          // Clear data only if isParticipantGameStarted is explicitly false
          localStorage.clear();
          console.log("Game not started, clearing localStorage.");
        } else {
          // If isParticipantGameStarted is undefined or true, just log it
          // console.log("Game is in progress or data is incomplete.");
        }
      } catch (error) {
        console.error("Failed to check game start status:", error);
      }
    };

    // Run the check initially
    checkExpiration();

    // Set an interval to check every 10 seconds
    const intervalId = setInterval(checkExpiration, 10000);

    return () => {
      // Cleanup the interval and event listener when component unmounts
      clearInterval(intervalId);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [code]); // Dependency on `code` to trigger this effect


  useEffect(() => {
    // Retrieve the stored code from localStorage
    const storedCode = localStorage.getItem("code");


    // Check if the URL contains a code
    if (code) {
      // If a stored code exists and it doesn't match the URL code
      if (storedCode && storedCode !== code) {
        console.error("Error: URL code does not match the stored code.");
        localStorage.clear(); // Clear all stored data to avoid conflicts

        setCurrentScreen("EnterParticipantName"); // Redirect to participant name entry screen
      } else if (!storedCode) {
        // If no code is stored, save the URL code to localStorage
        localStorage.setItem("code", code);


      }
    } else if (!storedCode) {
      // console.error("Error: Code not found in localStorage or URL.");

    }
    // const initialCode = getParticipantData(urlCode, "code") || localStorage.getItem("code");
    // console.log("initialCode:", initialCode);
  }, [urlCode]); // // Dependency array ensures the effect runs when urlCode changes



  return (
    <>
      <Helmet>
        <title>For Participants | TriviaMaker - Participants</title>
        <meta name="description" content="Test your knowledge and have fun learning with TriviaMaker! TriviaMaker is a free game platform.That lets you play trivia on any subject, language, or device – perfect for all ages of learners!" />
      </Helmet>
      {currentScreen === "EnterParticipantName" && (
        <EnterParticipantName onNavigate={handleNavigate} code={code} />
      )}

      {currentScreen === "AllocatedTeamToParticipant" && (
        <AllocatedTeamToParticipant onNavigate={handleNavigate} code={code} />
      )}
      {currentScreen === "WaitingScreen" && (
        <WaitingScreen onNavigate={handleNavigate} code={code} />
      )}
      {currentScreen === "LeaderBoard" && (
        <LeaderBoard onNavigate={handleNavigate} code={code} />
      )}
      {currentScreen === "PlayScreenParticipant" && (
        <PlayScreenParticipant onNavigate={handleNavigate} code={code} />
      )}
      {currentScreen === "PlayerWinnerParticipant" && (
        <PlayerWinnerParticipant onNavigate={handleNavigate} code={code} />
      )}
    </>
  );
}


function UrlWithOutCode() {
  useEffect(() => {
    // Redirect to the external URL
    console.log("UrlWithOutCode called...")
    window.location.href = "https://play.triviamaker.com/";
  }, []);

  return null; // This component does not render anything
}

function HangManClassroomModeParticipantside() {
  const noSleep = new NoSleep();
  const code = localStorage.getItem("code");
  const dispatch = useDispatch();
  // Capture the 'code' from the URL// Change this to capture the 'code' from the URL
  const { slug: urlCode } = useParams(); // Renamed slug to urlCode
  console.log(urlCode, 'urlCode');

  // localStorage.setItem("code", code);

  // Global exitgame handler for WebView - always available on every classroom participant screen
  // When WebView calls exitgame(), just clean up and redirect - do NOT delete database
  useEffect(() => {
    const exitCode = code || urlCode;
    const handler = () => {
      console.log("exitgame: classroom participant side called");
      console.log("exitgame: current screen:", localStorage.getItem("currentScreenParticipantside"));
      console.log("exitgame: code:", exitCode);

      // Clean up localStorage
      const keysToRemove = [
        'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
        'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
        'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
      ];
      keysToRemove.forEach((key) => window.localStorage.removeItem(key));
      console.log("exitgame: localStorage cleared");

      // Native bridge for iOS
      const isIOSNative = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeProcess);

      if (isIOSNative) {
        try {
          window.webkit.messageHandlers.nativeProcess.postMessage("ExitGame");
          console.log("exitgame: sent ExitGame to native bridge");
        } catch (e) {
          console.error("exitgame: native bridge error:", e);
        }
      } else {
        // Redirect to play.triviamaker.com for browsers
        console.log("exitgame: redirecting to play.triviamaker.com");
        setTimeout(() => {
          window.location.href = 'https://play.triviamaker.com/';
        }, 200);
      }
    };

    window._exitgameReactHandler = handler;
    window.exitgame = handler;
    console.log("exitgame: handler registered on classroom participant side");
  });

  const [loading, setLoading] = useState(true);
  const [progress, setProgressState] = useState(0);
  const [localProgress, setLocalProgress] = useState(0);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [logoLoadedbackgroundImg, setLogoLoadedbackgroundImg] = useState(false);
  const fontfamily = useSelector((state) => state.gameSettings.fontfamily);
  console.log(fontfamily, "fontfamily");
  const [wakeLock, setWakeLock] = useState(null);
  const [currentScreen, setCurrentScreen] = useState(() => {
    const storedScreen = localStorage.getItem("currentScreenParticipantside");
    return storedScreen ? storedScreen : "EnterPin";
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Convert all query params to an object
  const allQueryParams = {};
  for (const [key, value] of queryParams.entries()) {
    allQueryParams[key] = value;
  }

  const handleNavigate = (screen) => {
    setCurrentScreen(screen);
    localStorage.setItem("currentScreenParticipantside", screen);
  };


  useEffect(() => {
    let startY = 0;  // To track the initial Y position on touch start

    const handleTouchStart = (e) => {
      // Record the starting Y position when the touch starts
      startY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;

      // Check if the user is at the top of the page and performing a downward scroll
      if (window.scrollY === 0 && currentY > startY) {
        e.preventDefault();  // Prevent the pull-to-refresh
      }
    };

    // Add touch event listeners
    document.addEventListener('touchstart', handleTouchStart, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  useEffect(() => {
    // Dynamically set the font family in the root CSS
    console.log('--main-font', fontfamily);
    const selectedFont = fontfamily || 'Museo'; // Default to 'Museo' if no font is set
    document.documentElement.style.setProperty('--main-font', selectedFont); // Apply the dynamic font

  }, [fontfamily]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const startTime = Date.now();
      localStorage.setItem("startTime", startTime.toString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    console.log("handleBeforeUnload called...")
    const checkExpiration = async () => {
      try {
        const response = await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`);
        const data = await response.json();
        dispatch(setfontfamily(`${data.fontfamily}`));
        console.log(data.fontfamily, "data.IsFontFamily");
        if (!data) {
          // If no data is returned, the game data is not available, consider the game not started
          console.log("No data found for the game.");
        } else if (data.isParticipantGameStarted === false) {
          // Clear data only if isParticipantGameStarted is explicitly false
          localStorage.clear();
          console.log("Game not started, clearing localStorage.");
        } else {
          // If isParticipantGameStarted is undefined or true, just log it
          console.log("Game is in progress or data is incomplete.");
        }
      } catch (error) {
        console.error("Failed to check game start status:", error);
      }
    };

    // Run the check initially
    checkExpiration();

    // Set an interval to check every 10 seconds
    const intervalId = setInterval(checkExpiration, 10000);

    return () => {
      // Cleanup the interval and event listener when component unmounts
      clearInterval(intervalId);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [code]); // Dependency on `code` to trigger this effect


  useEffect(() => {
    console.log("urlCode:", urlCode);

    // Retrieve the stored code from localStorage
    const storedCode = localStorage.getItem("code");

    // Check if the URL contains a code
    if (urlCode) {
      // If a stored code exists and it doesn't match the URL code
      if (storedCode && storedCode !== urlCode) {
        console.error("Error: URL code does not match the stored code.");
        localStorage.clear(); // Clear all stored data to avoid conflicts
        setCurrentScreen("EnterParticipantName"); // Redirect to participant name entry screen
      } else if (!storedCode) {
        // If no code is stored, save the URL code to localStorage
        localStorage.setItem("code", urlCode);

      }
    } else if (!storedCode) {
      console.error("Error: Code not found in localStorage or URL.");

    }
  }, [urlCode]); // Dependency array ensures the effect runs when urlCode changes



  return (
    <>
      <Helmet>
        <title>For Participants | TriviaMaker - Participants</title>
        <meta name="description" content="Test your knowledge and have fun learning with TriviaMaker! TriviaMaker is a free game platform.That lets you play trivia on any subject, language, or device – perfect for all ages of learners!" />
      </Helmet>
      {currentScreen === "EnterPin" && (
        <EnterPin onNavigate={handleNavigate} />
      )}
      {currentScreen === "AllocatedTeamToParticipant" && (
        <AllocatedTeamToParticipant onNavigate={handleNavigate} />
      )}
      {currentScreen === "WaitingScreen" && (
        <WaitingScreen onNavigate={handleNavigate} />
      )}
      {currentScreen === "LeaderBoard" && (
        <LeaderBoard onNavigate={handleNavigate} />
      )}
      {currentScreen === "PlayScreenParticipant" && (
        <PlayScreenParticipant onNavigate={handleNavigate} />
      )}
      {currentScreen === "PlayerWinnerParticipant" && (
        <PlayerWinnerParticipant onNavigate={handleNavigate} />
      )}
    </>
  );
}

function App() {

  function RootHandler() {
    const [searchParams] = useSearchParams();
    const playCode = searchParams.get('p');
    const studentCode = searchParams.get('c');

    if (playCode) {
      // Render participant mode directly with the play code
      return <HangManCrowdModeParticipantside playCode={playCode} />;
    }

    if (studentCode) {
      // Render classroom mode directly with the student code as slug
      return <HangManClassroomModeParticipantside slug={studentCode} />;
    }

    // Default: render basic mode
    return <HangmanApp />;
  }
  return (
    <Routes>
      {/* BASIC */}
      <Route path="/Play/hangman/:id" element={<HangmanApp />} />
      <Route path="/Play/hangman/:id/iframe" element={<HangmanApp />} />
      <Route path="/Play/hangman/:id/embedded" element={<HangmanApp />} />
      <Route path="/Play/hangman/:id/spacin=30px&platform=iOS" element={<HangmanApp />} />
      <Route path="/Play/hangman/:id/spacin=30px&platform=android" element={<HangmanApp />} />
      <Route path="/" element={<RootHandler />} />
      {/* playlone */}
      <Route path="/Play/hangman/:id/m=play" element={<HangmanApp />} />
      {/* crowd mode Host side */}
      <Route path="/Play/hangman/:id/m=cr" element={<HangManCrowdMode />} />
      <Route path="/Play/hangman/:id/m=cr/spacin=30px&platform=iOS" element={<HangManCrowdMode />} />
      <Route path="/Play/hangman/:id/m=cr/spacin=30px&platform=android" element={<HangManCrowdMode />} />

      {/* crowmode participant side */}
      <Route path="/hangman" element={<HangManCrowdModeParticipantside />} />
      <Route path="/h/:code" element={<HangManCrowdModeParticipantside />} />
      <Route path="/h/" element={<UrlWithOutCode />} />
      <Route path="/h" element={<UrlWithOutCode />} />

      {/* classroom mode  */}
      <Route path="/Play/hangman/:id/m=cl/:clid" element={<HangManCrowdMode />} />
      <Route path="/student/:slug" element={<HangManClassroomModeParticipantside />} />
      {/* CROWD */}
    </Routes>
  );
}
export default App;
